/*=========================================================================================
  File Name: moduleMapMutations.js
  Description: Map Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	UPDATE_PREFERENCE(state, payload) {
		Object.assign(state, {...payload});
	},
};
